const staticText = {
  successMessage: 'Please check your inbox. Once your email has been verified you may return to this screen and refresh the page.',
  tryAgainMessage: 'Didn\'t receive the email? ',
  resendEmailButtonText: 'Resend verification email',
};

export default staticText;
